import React from "react";
import InputField from "./InputField";
import "./FormInputs.css";
import InputDatePicker from "./InputDatePicker";
import InputDropdown from "./InputDropdown";

/**
 *
 * @param {Object[]} fieldsConfig - array with fields configuration
 * @param {number} fieldsConfig[].key - key for list
 * @param {string} fieldsConfig[].name - field name
 * @param {string} fieldsConfig[].discription - description
 * @param {string} fieldsConfig[].component - input|dropdown|datePicker
 * @param {Object} fieldsConfig[].wrapperProps - props for wrapper div
 * @param {Object} fieldsConfig[].titleProps - props for title div
 * @param {Object} fieldsConfig[].inputProps - props for input component
 * @param {Object[]} fieldsConfig[].options - options for dropdown
 * @param {string} fieldsConfig[].options[].text - option text
 * @param {number | string} fieldsConfig[].options[].value - option value
 * @param {string} fieldsConfig[].type - input type
 * @param {string} fieldsConfig[].translatePath - text for translate
 * @param {string} fieldsConfig[].title - title of input
 * @param {Object} data - title of input
 * @param {func[]} actions - array of actions
 * @param {func} actions.onChange - func for onChange
 */
const FormInputs = ({ fieldsConfig, data, actions }) => {
  const getComponent = ({ field, data, actions }) => {
    switch (field.component) {
      case "input":
        return (
          <div
            className="form-input row"
            key={field.key}
            {...field.wrapperProps}
          >
            <span className="title" {...field.titleProps}>
              {field.title}:
            </span>
            <InputField
              objData={data}
              objFieldName={field.name}
              onChange={actions.onChange}
              className="field"
              {...field.inputProps}
            />
          </div>
        );
      case "datePicker":
        return (
          <div
            className="form-input row"
            key={field.key}
            {...field.wrapperProps}
          >
            <span className="title" {...field.titleProps}>
              {field.title}:
            </span>
            <InputDatePicker
              objData={data}
              objFieldName={field.name}
              onChange={actions.onChange}
              className="field"
              {...field.inputProps}
            />
          </div>
        );
      case "dropdown":
        return (
          <div
            className="form-input row"
            key={field.key}
            {...field.wrapperProps}
          >
            <span className="title" {...field.titleProps}>
              {field.title}:
            </span>
            <InputDropdown
              className="field"
              fluid
              lazyLoad
              search
              selection
              objData={data}
              objFieldName={field.name}
              options={field.options}
              onChange={actions.onChange}
              {...field.inputProps}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {fieldsConfig.map((field) => {
        return field.isHide !== true && getComponent({ field, data, actions });
      })}
    </>
  );
};

export default FormInputs;
